import * as React from 'react';
import { DropDownProps } from 'antd/lib/dropdown';
import { ExtraMenu } from 'components';

type DropdownCellProps = DropDownProps;

const DropdownCell: React.FC<DropdownCellProps> = props => <ExtraMenu {...props} />;

export default DropdownCell;
